import React, {useState,useContext,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { IsAuthContext } from 'app/App';
import swal from "sweetalert2";
import axios from 'axios'

const CategorieTvaDefaultForm = (props) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [validButton,setValidButton] = useState(false)
    const [success, setSuccess] = useState(false)
    const [categorieTvaDefault,setCategorieTvaDefault] = useState('')

    useEffect(function () {
        setCategorieTvaDefault(props.defaultValue)
    }, [props.defaultValue])

    const submit = async (e) => {
        e.preventDefault()
        setValidButton(true)

        let obj={
            categorie_tva_default: categorieTvaDefault=='' ? null : categorieTvaDefault
        }

        const response  = await axios.put(process.env.REACT_APP_API_URL+props.url, obj
        ).then((response)=> {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(t(messageError), "", "error");
            }else {
                setSuccess(true)
            }
        }).catch((error)=>{
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }else {
                messageError='unknowError'
            }
            swal.fire(t(messageError), "", "error");
        })
        setValidButton(false)
        setTimeout(()=>{
            setSuccess(false)
        }, 1000)
    };

    return(<form onSubmit={(e)=>submit(e)}>
        <span className='row'>
            <span className="col-10">
                <select disabled={validButton} value={categorieTvaDefault} className='form-control' onChange={(e)=>setCategorieTvaDefault(e.target.value)}>
                    <option value=''>{t('noDefaultCategorieTva')}</option>
                    {authParam.company.advanceparams.hasOwnProperty('categorie_tva') && authParam.company.advanceparams.categorie_tva!=null && authParam.company.advanceparams.categorie_tva.length!=0 &&
                        authParam.company.advanceparams.categorie_tva.map((categorie,index)=>(
                            <option key={index} value={categorie.name}>{categorie.name}</option>
                        ))
                    }
                </select>
            </span>
            <span className="col-2">
                <button disabled={validButton} className="btn btn-primary">
                    {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                </button>
            </span>
            {(success) ? <div className="col-12"><div className="alert alert-success mt-3">{t('successOperation')}</div></div> : false}
        </span>
        </form>
    )
}

export default CategorieTvaDefaultForm;
